import seaways from 'seaways'
import { axiosClient } from '../../services/axios-client'

const http = seaways.createClient(axiosClient)

http.getPlugins = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/plugins'
}
http.updatePlugin = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/plugins/{uuid}/settings'
}

http.state = {
  method: 'post',
  path: '/projects/{projectId}/forms/{endpointId}/plugins/{uuid}/state'
}

async function getPlugins({ projectId, endpointId }) {
  return (await http.getPlugins({ pathParams: { projectId, endpointId } })).data
}

async function state({ projectId, endpointId, uuid, data }) {
  return (
    await http.state({ pathParams: { projectId, uuid, endpointId }, data })
  ).data
}

async function updatePlugin({ projectId, endpointId, uuid, settings }) {
  return (
    await http.updatePlugin({
      data: settings,
      pathParams: { projectId, endpointId, uuid }
    })
  ).data
}

export default { getPlugins, updatePlugin, state }
